import React, { Component } from "react";
import { notification, Typography, Tag, Space } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import {
  ModalItem,
  TableItem,
  ButtonItem,
  SelectVendedoresItem,
} from "../../../../Components/Items";
import axios from "axios";

const { Text } = Typography;

class ModalAsignarLeadsShopify extends Component {
  state = {
    leads: [],
    loading: false,
    selectedRowKeys: [],
    vendedorId: undefined,
    asignando: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarLeads();
    }
  }

  cargarLeads = () => {
    this.setState({ loading: true, selectedRowKeys: [], vendedorId: undefined });
    axios
      .post(
        "shopify/leadsShopifyPendientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ leads: res.data.leads });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar leads pendientes." }))
      .finally(() => this.setState({ loading: false }));
  };

  asignarSeleccionados = () => {
    const { selectedRowKeys, vendedorId } = this.state;
    if (!vendedorId) {
      notification.warning({ message: "Selecciona un vendedor antes de asignar." });
      return;
    }
    if (selectedRowKeys.length === 0) {
      notification.warning({ message: "Selecciona al menos un lead." });
      return;
    }

    this.setState({ asignando: true });

    Promise.all(
      selectedRowKeys.map((leadId) =>
        axios.post(
          "shopify/asignarLeadShopify",
          { empresaId: this.props.empresaId, leadId, usuarioId: vendedorId },
          { headers: this.props.headersToken },
        ),
      ),
    )
      .then((resultados) => {
        const exitosos = resultados.filter((r) => r.data.success === 2).length;
        notification.success({
          message: `${exitosos} lead${exitosos !== 1 ? "s" : ""} asignado${exitosos !== 1 ? "s" : ""} correctamente.`,
        });
        this.setState((prev) => ({
          leads: prev.leads.filter((l) => !prev.selectedRowKeys.includes(l._id)),
          selectedRowKeys: [],
          vendedorId: undefined,
        }));
        this.props.onLeadAsignado?.();
      })
      .catch(() => notification.error({ message: "Error al asignar leads." }))
      .finally(() => this.setState({ asignando: false }));
  };

  render() {
    const { visible, onCancel, headersToken, empresaId } = this.props;
    const { leads, loading, selectedRowKeys, vendedorId, asignando } = this.state;

    const columnas = [
      {
        title: "Lead",
        key: "lead",
        render: (_, r) => (
          <div>
            <Text strong>{r.descripcion || "—"}</Text>
            {r.correo && (
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {r.correo}
                </Text>
              </div>
            )}
          </div>
        ),
      },
      {
        title: "Embudo",
        key: "embudo",
        width: 180,
        render: (_, r) => (
          <Tag color="blue">{r.embudoId?.nombreEmbudo ?? "—"}</Tag>
        ),
      },
    ];

    return (
      <ModalItem
        title={
          <span>
            <UserAddOutlined style={{ marginRight: 8, color: "#95bf47" }} />
            Leads Shopify por asignar ({leads.length})
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={700}
        spinning={loading}
        destroyOnClose
      >
        <Space style={{ marginBottom: 16, width: "100%", paddingTop: 12 }}>
          <SelectVendedoresItem
            headersToken={headersToken}
            empresaId={empresaId}
            embudoId={leads[0]?.embudoId?._id}
            placeholder="Selecciona vendedor"
            value={vendedorId}
            onChange={(uid) => this.setState({ vendedorId: uid })}
            style={{ width: 260 }}
          />
          <ButtonItem
            azul
            icon={<UserAddOutlined />}
            loading={asignando}
            disabled={!vendedorId || selectedRowKeys.length === 0}
            onClick={this.asignarSeleccionados}
          >
            Asignar {selectedRowKeys.length > 0 ? `(${selectedRowKeys.length})` : "seleccionados"}
          </ButtonItem>
        </Space>

        <TableItem
          dataSource={leads}
          columns={columnas}
          rowKey="_id"
          loading={loading}
          defaultPageSize={15}
          locale={{ emptyText: "Sin leads pendientes de asignar." }}
          size="small"
          rowSelection={{
            selectedRowKeys,
            onChange: (keys) => this.setState({ selectedRowKeys: keys }),
          }}
        />
      </ModalItem>
    );
  }
}

export default ModalAsignarLeadsShopify;
